import { useMemo } from "react";
import * as Team from "src/state/modules/team";
import { useGetTeamLiveGamesByIDQuery } from "src/state/modules/api";
import { useGameState } from "src/components/util/useGameState";
import { computeScoreboard, Scoreboard } from "src/utils/scoreboard";

const LIVE_POLL_MS = 20000;

// Live scoreboard for an in-progress game: scores/inning/outs come from replaying the game stream
// through sabertooth (useGameState live mode — GameChanger's authoritative book), and the opponent
// name / which side we are come from the /live record. Returns null until both are ready.
export function useLiveScoreboard(team: Team.Team | undefined, eventId: string): Scoreboard | null {
  const { data: liveGames } = useGetTeamLiveGamesByIDQuery(team?.id ?? "", {
    skip: !team,
    pollingInterval: LIVE_POLL_MS,
    skipPollingIfUnfocused: true,
  });
  const live = (liveGames ?? []).find((g) => g.event_id === eventId);

  const { state } = useGameState(team, eventId, { live: true });

  return useMemo(() => computeScoreboard(state, team, live), [state, team, live]);
}
